<smart-modal [Id]="'RecommendedListModal'" [Title]="'Add to recommendation list'">
    <div modal-body class="recommendedList">
        <div class="row">
            <div class="col-md-auto p-0">
                <label for="CreateNewList" class="col-form-label">New list:</label>
            </div>
            <div class="col-md MobileFix">
                <input type="text" placeholder="Recommendation title" class="form-control form-control-sm" id="CreateNewList" [(ngModel)]="NewRecommendationName">
            </div>
            <div class="col-md-2 pl-0 btnCreateMobileFix">
                <button type="button" class="btn btn-primary btn-sm" (click)="CreateNewRecommendation()" title="Create New Recommendation">Create</button>
            </div>
        </div>

        <div class="row">
            <div class=" col-md-12 p-0">
                <div class="table-responsive table-sm">
                    <table class="table table-hover" *ngIf="RecommendedList">
                        <thead>
                          <tr>
                            <th scope="col">Recommendation list</th>
                            <th scope="col" class="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let recommendedList of RecommendedList">
                            <td scope="row" class="form-check">
                                <input type="checkbox" class="form-check-input" [checked]="recommendedList.IsExist"
                                (change)="OnRecommendationChange(recommendedList.Id)" id="chkRecommendedList_{{recommendedList.Id}}" />
                                <label class="form-check-label" for="chkRecommendedList_{{recommendedList.Id}}">{{recommendedList.Title}} - [{{recommendedList.Id}}]
                                ({{recommendedList.Total}})</label>
                            </td>
                            <td class="text-center">
                                <button (click)="OnRecommendationRemove(recommendedList.Id)">
                                    <b><i title="Remove recommendation" class="far fa-trash-alt"></i></b>
                                </button>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                    <list-loader></list-loader>
                </div>
            </div>
            <!-- <div class=" col-md-12 p-0 text-right">
                <a href="javascript:(void)" title="View all recommendations" (click)="ViewAll()">View all recommendations</a>
            </div> -->
        </div>
    </div>
</smart-modal>

<button id="btnViewAllRecommendations" class="d-none" data-toggle="modal" data-target="#RecommendedListModal"></button>